module.exports = __webpack_public_path__ + "static/media/sport-banner-horse.5349ab35.svg";